import React from "react";
import styled from "styled-components";
import { OfficeInfo } from "@src/api/expert/expertInfo";
import MgInput from "@src/components/input/MgInput";

interface OfficeInfoDisplayProps {
    officeInfo: OfficeInfo;
    isEditing?: boolean;
    onUpdateOffice?: (field: keyof OfficeInfo, value: string) => void;
}

const UserOfficeInfoCard: React.FC<OfficeInfoDisplayProps> = ({ officeInfo, isEditing = false, onUpdateOffice }) => {
    const handleChange = (field: keyof OfficeInfo) => (e: React.ChangeEvent<HTMLInputElement>) => {
        onUpdateOffice?.(field, e.target.value);
    };

    const renderEditableField = (field: keyof OfficeInfo, label: string) =>
        isEditing ? (
            <EditableValue
                value={officeInfo[field]?.toString() || ""}
                onChange={handleChange(field)}
                placeholder={`${label}을(를) 입력하세요`}
                type="text"
            />
        ) : (
            <Value>{officeInfo[field] || "-"}</Value>
        );

    return (
        <Container>
            <InfoItem>
                <Label>성함</Label>
                {renderEditableField("ceo", "성함")}
            </InfoItem>
            <Divider />
            <InfoItem>
                <Label>사무소명</Label>
                {renderEditableField("name", "사무소명")}
            </InfoItem>
            <Divider />
            <InfoItem>
                <Label>중개등록번호</Label>
                {renderEditableField("registrationNumber", "중개등록번호")}
            </InfoItem>
            <Divider />
            <InfoItem>
                <Label>전화번호</Label>
                {renderEditableField("phone", "전화번호")}
            </InfoItem>
            <Divider />
            <InfoItem>
                <Label>소재지</Label>
                {renderEditableField("address", "소재지")}
            </InfoItem>
        </Container>
    );
};

export default UserOfficeInfoCard;

const Container = styled.div`
    background-color: #fbf8f8;
    border-radius: 8px;
    padding: 16px;
    display: flex;
    flex-direction: column;
`;

const InfoItem = styled.div`
    display: flex;
    flex-direction: column;
    padding: 8px 0;
`;

const Label = styled.span`
    font-size: 12px;
    color: #666;
    margin-bottom: 4px;
`;

const Value = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: #000;
`;

const Divider = styled.div`
    height: 1px;
    background-color: #ccc;
    margin: 0;
`;

const EditableValue = styled(MgInput)`
    font-size: 14px;
    font-weight: 500;
    color: #000;
    background-color: transparent;
    border: none;
    padding: 0;
    width: 100%;

    &:focus {
        outline: none;
    }
`;
